import { all, call } from 'redux-saga/effects';

import braintreeSetup from './braintreeSetup';
import checkoutBraintree from './checkoutBraintree';
import checkoutNeweb from './checkoutNeweb';
import checkoutOffline from './checkoutOffline';
import checkout2C2P from './checkout2C2P';
import checkoutLinePay from './checkoutLinePay';
import paymentReceipt from './paymentReceipt';
import changePlan from './changePlan';
import discountCode from './discountCode';
import deliveryInfo from './deliveryInfo';

export default function*() {
  yield all([
    call(braintreeSetup),
    call(checkoutBraintree),
    call(checkoutNeweb),
    call(checkoutOffline),
    call(checkout2C2P),
    call(checkoutLinePay),
    call(paymentReceipt),
    call(changePlan),
    call(discountCode),
    call(deliveryInfo),
  ]);
}



// WEBPACK FOOTER //
// ./app/sagas/purchase/index.js